import React from "react";
import { Button } from "@fluentui/react-components";
import { AddRegular } from "@fluentui/react-icons/svg/add";
import { useTranslation } from "react-i18next";

interface CatalogueSuggestSourceCardProps {
  onClick: () => void;
}

export const CatalogueSuggestSourceCard: React.FC<
  CatalogueSuggestSourceCardProps
> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      appearance="outline"
      className="catalogue-suggest-source-card"
      icon={<AddRegular />}
      onClick={onClick}
    >
      {t("board.connections.catalogue.suggestOne")}
    </Button>
  );
};
